import { render, staticRenderFns } from "./PreviewLocationAttribute.vue?vue&type=template&id=03875528&scoped=true"
import script from "./PreviewLocationAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewLocationAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03875528",
  null
  
)

export default component.exports